import ageWithTooltip from "discourse/helpers/age-with-tooltip";

const RelativeDate = <template>{{ageWithTooltip @date}}</template>;

export default RelativeDate;
